/* ============================================================
   Hero enhancement - text/CTA reveal + image parallax
   Reuses local GSAP (gsap.min.js, ScrollTrigger.min.js).
   No-flash: content is pre-hidden via the .hero-enh <html> class
   (set by the snippet) and revealed here; reduced-motion & load
   failures fall back to fully visible.
   ============================================================ */
(function () {
  'use strict';

  var cfg = window.HERO_ENHANCE || {};
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll() { document.documentElement.classList.remove('hero-enh'); }

  if (reduced) { showAll(); return; }

  function loadScript(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  function ensureGSAP() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    var cdn = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/';
    return loadScript(cfg.gsap || cdn + 'gsap.min.js')
      .then(function () { return loadScript(cfg.st || cdn + 'ScrollTrigger.min.js'); })
      .then(function () { window.gsap.registerPlugin(window.ScrollTrigger); });
  }

  function run() {
    var gsap = window.gsap;
    var heroes = document.querySelectorAll('.hero');
    if (!heroes.length) { showAll(); return; }

    Array.prototype.forEach.call(heroes, function (hero) {
      /* ---- Text + CTA reveal ---- */
      var wrap = hero.querySelector('.hero__content-wrapper');
      var targets = wrap
        ? Array.prototype.slice.call(wrap.querySelectorAll('.text-block, .button, .button-secondary, .button-unstyled'))
        : [];
      if (targets.length) {
        gsap.set(targets, { opacity: 0, y: 26 });
        gsap.timeline({ scrollTrigger: { trigger: hero, start: 'top 80%', once: true } })
          .to(targets, {
            opacity: 1, y: 0, duration: 0.9, stagger: 0.12, ease: 'power3.out', delay: 0.15
          });
      }

      /* ---- Image parallax on scroll ---- */
      var media = hero.querySelectorAll('.hero__media');
      if (media.length) {
        gsap.set(media, { scale: 1.1, transformOrigin: 'center center', force3D: true, willChange: 'transform' });
        gsap.fromTo(media,
          { yPercent: -4 },
          {
            yPercent: 4, ease: 'none',
            scrollTrigger: { trigger: hero, start: 'top bottom', end: 'bottom top', scrub: true }
          });
      }
    });

    // content already carries inline opacity from gsap.set - safe to drop the guard class
    showAll();
  }

  ensureGSAP().then(run).catch(showAll);
})();
